import RandomGen7Teams from '../gen7/random-teams';

export class RandomGen7PokebilitiesTeams extends RandomGen7Teams {}

export default RandomGen7PokebilitiesTeams;
